import React from 'react';

function NotFound() {
    return (
        <main lang="de">
            <article>
                <header>
                    <h2>
                        <b>You have landed on a page that doesn&apos;t exist</b>
                    </h2>
                </header>
                <p>
                    <b>You can now return to:</b>
                </p>
                <p>
                    <a href="/dashboard">Dashboard</a>
                </p>
            </article>
        </main>
    );
}

export default NotFound;
